import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './Th.css';

const Th = ({ children, className, ...rest }) => (
  <th className={classNames('th', className)} {...rest} >
    { children }
  </th>
);

Th.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

export default Th;



// WEBPACK FOOTER //
// ./src/components/Th/Th.jsx